import { Injectable, inject, signal } from '@angular/core';
import { QueryBuilder } from '@softline/core';
import { ClaimReportTruckRepository } from '../repositories/claim-report-truck.repository';
import {
  ClaimReportTruck,
  ClaimReportTruckQueryRow,
} from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportTruckService {
  private readonly repository = inject(ClaimReportTruckRepository);

  readonly trucks = signal<ClaimReportTruck[]>([]);
  readonly isLoading = signal(false);
  readonly error = signal<unknown>(null);

  async load(documentId: string): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);
    try {
      const query = new QueryBuilder<ClaimReportTruckQueryRow>()
        .column('truck.name')
        .column('truck.truck')
        .filter({ type: 'stringEquals', name: 'sales_order.sale_department', value: 'V' })
        .filter({ type: 'stringEquals', name: 'sales_order.id', value: documentId })
        .start(0)
        .end(100)
        .build();
      const result = await this.repository.load({ query });
      const rows = (result?.data ?? []) as unknown as ClaimReportTruckQueryRow[];
      this.trucks.set(
        rows.map((row) => ({
          name: row.truck.name,
          truck: row.truck.truck,
        }))
      );
    } catch (e) {
      this.error.set(e);
      throw e;
    } finally {
      this.isLoading.set(false);
    }
  }
}
